import { useQuestionizerStore } from "../types/state.ts";
import Toggle from "./toggle.tsx";

export default function InputGewerbeGebaeude (props: {id: number, label: string, icon: string, icon_active?:string, onBlur?: ()=>void}){
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const gewerbegebaeude = useQuestionizerStore((state) => state.gewerbegebaeude);
  const setGewerbegebaeude = useQuestionizerStore((state) => state.setGewerbegebaeude);

  const label = useQuestionizerStore((state) => state.translation.errors['input-gewerbegebaeude']);
 
  return <div className="flex flex-row justify-center">
            <Toggle id={props.id.toString()} label={props.label || label} icon={props.icon} icon_active={props.icon_active} value={gewerbegebaeude || false} 
            onBlur={props.onBlur}
            onChange={(_)=>{
              setGewerbegebaeude(!gewerbegebaeude);
              updateValidation();
              //setValidation(props.id, {message:"", valid: true});
            }}/>
        </div>
}